let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("7EorR"), load("ffEVr"), load("awqCy"), load("4uVag")]).then(() => parcelRequire('3Atou'));